import { defineStore } from "pinia";

type CableConnectionStoreType = {
  isLost: boolean;
};

/**
 * Whether the tab still has a live cable.
 *
 * A cable the client closed for good — a refused handshake, or a transport the
 * monitor gave up reconnecting — takes every realtime feature of the tab with
 * it and does not come back on its own. The flag is written by
 * `internalCableClient` and read by `CableConnectionAlert`, so the banner does
 * not have to reach into the service.
 */
export const useCableConnectionStore = defineStore("cableConnection", {
  state: (): CableConnectionStoreType => ({
    isLost: false,
  }),
  actions: {
    markLost() {
      this.isLost = true;
    },
    markConnected() {
      this.isLost = false;
    },
  },
});
